import { cn } from "@shared/ui/utils";

interface SectionTitleProps {
  title: string;
  className?: string;
}

export const SectionTitle = ({ title, className }: SectionTitleProps) => {
  return (
    <h3
      className={cn(
        "text-center text-[30px] font-semibold drop-shadow-[2px_6px_6px_rgb(255,255,255,0.15)] md:text-left",
        className,
      )}
    >
      {title}
    </h3>
  );
};
